// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import Path from 'routes/path'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import MainContents from 'components/templates/MainContents'
import Loading from 'components/atoms/Loading'
import LoadingView from 'components/atoms/LoadingView'
import NoItemDescription from 'components/atoms/NoItemDescription'
import ReservationListHeading from 'components/molecules/ReservationListHeading'
import ReservationItem from 'components/molecules/ReservationItem'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { type ReservationType } from 'types/reservation'

const ReservationListBody = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const ReservationListItem = styled.li`
  border-bottom: 1px solid ${Colors.grayD};

  &:first-child {
    border-top: 1px solid ${Colors.grayD};
  }
`

export type PropTypes = {
  reservationList: Array<ReservationType>,
}

export default function ReservationListSection(props: PropTypes) {
  return (
    <Fragment>
      <ReservationListHeading
        selectProps={{
          size: 'large',
          defaultValue: 1,
        }}
      >
        {i18n.t('page.dashboard.reservation.headReservastion')}
      </ReservationListHeading>
      <ReservationListBody>
        {props.reservationList.length === 0 && !props.isLoading ? (
          <NoItemDescription>
            {i18n.t('page.dashboard.reservation.noReservation')}
          </NoItemDescription>
        ) : (
          <ul>
            {props.reservationList.map((reservation, index) => (
              <ReservationListItem key={`reservation_list_item_${index}`}>
                <ReservationItem
                  roomName={reservation.roomName}
                  color={reservation.color}
                  thumbnail={reservation.thumbnail}
                  ownerName={reservation.ownerName}
                  // ToDo: お問い合わせのとき
                  paymentMethodText={reservation.payingMethodText}
                  id={reservation.id}
                  uid={reservation.uid}
                  reservedDateText={reservation.reservedDateText}
                  // ToDo: お問い合わせのとき
                  totalAmount={reservation.totalAmount}
                  dueDate={reservation.dueDate}
                  topHost={reservation.topHost}
                  profileImage={reservation.profileImage}
                  notReply={reservation.notReply}
                  reservationPhaseTexts={reservation.reservationPhaseTexts}
                  unapprovedReservation={reservation.unapprovedReservation}
                  isReadMessage={reservation.isReadMessage}
                  href={reservation.href}
                  small
                />
              </ReservationListItem>
            ))}
          </ul>
        )}
      </ReservationListBody>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationListSection/index.jsx